<template>
    <div class="menu-wrap">
        <ul>
            <li @click="moveTab('home')" :class="{'active':$router.currentRoute.name=='home'}">
                <img src="@/assets/img/home.svg" alt="HOME" v-if="$router.currentRoute.name!='home'">
                <img src="@/assets/img/home_active.svg" alt="HOME" v-else>
                <span> HOME</span>
            </li>
             <!-- class="active" -->
            <li @click="moveTab('reservation_coaching')" :class="{'active':$router.currentRoute.name=='coaching_message'
            || $router.currentRoute.name == 'reservation_coaching'
            || $router.currentRoute.name == 'complate_coaching'}">

                <img src="@/assets/img/coaching_active.svg" alt="나의 코칭" v-if="$router.currentRoute.name=='coaching_message'
            || $router.currentRoute.name == 'reservation_coaching'
            || $router.currentRoute.name == 'complate_coaching'">
                <img src="@/assets/img/coaching.svg" v-else>


                <span> 나의 코칭</span>
            </li>
            <li @click="moveTab('myinfo')" :class="{'active':$router.currentRoute.name=='myinfo'}">
                <img src="@/assets/img/info.svg" alt="My Info" v-if="$router.currentRoute.name!='myinfo'">
                <img src="@/assets/img/info_active.svg" alt="My Info" v-else>
                <span> My Info</span>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name:'inc_tab',
    props:{
    },
    watch: {
        
    },
    mounted(){

    },
    methods:{
        moveTab(uri){
            this.$router.push(uri);
        }
    }
}
</script>
